import { SelectItem } from "primeng/api";

enum DeliveryAddressType {
    HomeAddress = 1,
    OrganisationAddress,
    NewAddress
}

const DeliveryAddressTypeMap: Record<DeliveryAddressType, string> = {
    1: "Patient Home Address",
    2: "Organisation Address",
    3: "New Address"
};

function createOptions() {
    return Object.keys(DeliveryAddressTypeMap)
        .map(k => +k as DeliveryAddressType)
        .map(k => <SelectItem>{ value: k, label: DeliveryAddressTypeMap[k] });
}

export { DeliveryAddressType, DeliveryAddressTypeMap, createOptions };
